import React from "react";
import { Box, Typography, Paper, Stack } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const ListVideoContainer = ({ videos, onVideoClick }) => {

  const formatDuration = (video_length) => {
    if (!video_length) return "";

    if (video_length.includes(":")) {
      const [hours, minutes] = video_length.split(":");

      if (parseInt(hours) > 0) {
        return `${hours}h ${minutes}m`;
      }

      return `${minutes}m`;
    }

    return "";
  };

  return (
    <Stack spacing={2}>
      {videos.map((video, index) => (
        <Paper
          key={video.id || index}
          onClick={() => onVideoClick?.(video)}
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "16px",
            backgroundColor: "#f2f3fc",
            border: "1px solid #a5aee1",
            borderRadius: "12px",
            boxShadow: "4px 4px 36px rgba(0, 0, 0, 0.05)",
            cursor: "pointer",
            transition: "background 0.2s ease",
            "&:hover": {
              backgroundColor: "#e9ecff",
            },
          }}
        >
          {/* TOP ROW */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", 
            }}
          >
            {/* LEFT SIDE */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <Box
                sx={{
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  border: "1px solid #273f77",
                  borderRadius: "8px",
                }}
              >
                <PlayArrowIcon sx={{ width: "18px", height: "18px" }} />
              </Box>

              <Typography
                variant="body1"
                sx={{
                  letterSpacing: "-0.01em",
                  lineHeight: "150%",
                  fontWeight: 500,
                }}
              >
                {video.title}
              </Typography>
            </Box>

            {/* RIGHT SIDE (Duration) */}
            {video.video_length && (
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 500,
                  color: "#5c5c5c",
                }}
              >
                {formatDuration(video.video_length)}
              </Typography>
            )}
          </Box>

      
          
        </Paper>
      ))}
    </Stack>
  );
};

export default ListVideoContainer;